import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';
import '../../index.css'; // Includes Hobo font

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // NEW
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axiosInstance.post('/api/admin/login', {
        email,
        password,
      });

      localStorage.setItem('adminToken', res.data.token);
      navigate('/Taylor');
    } catch (err) {
      console.error(err);
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-dvh flex flex-col bg-[#fef2f2] px-4 py-10">
      <div className="flex-1 flex flex-col items-center justify-center w-full">
      <h1 className="text-4xl font-hobo text-[#a62c2b] mb-6 text-center">
        Admin Login
      </h1>

      <div className="w-full max-w-md bg-white rounded-2xl shadow-md p-6 sm:p-8 border border-[#f8dcdc]">
        {error && (
          <p className="text-red-600 text-sm font-semibold mb-4 text-center">
            {error}
          </p>
        )}

        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="text"
            placeholder="Admin Username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#a62c2b] text-sm"
          />


          <input
            type="password"
            placeholder="Admin Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#a62c2b] text-sm"
          />

          <button
            type="submit"
            disabled={loading}
            className={`w-full font-semibold py-3 rounded-md transition duration-300 ${loading
                ? 'bg-[#a62c2b]/60 text-white cursor-not-allowed'
                : 'bg-[#a62c2b] hover:bg-[#8a1f1c] text-white'
              }`}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
      </div>
    </div>
  );
};

export default AdminLogin;
